/**
 * 事件收发管理类
 */
import Vue from 'vue'

const message = new Vue()
const callbackArr = {}

/**
 * 事件触发
 * @param eventName
 * @param args
 */
export function emitEvent(eventName, ...args) {
  message.$emit(eventName, ...args)
}

/**
 * 事件侦听
 * @param eventName
 * @param callback
 * @param keepBeforeListener 是否清理之前的所有侦听，默认为null，清理之前的侦听；如果要保留，请设置true
 */
export function onEvent(eventName, callback, keepBeforeListener) {
  if (!eventName) {
    return
  }
  if (keepBeforeListener) {
    !callbackArr[eventName] && (callbackArr[eventName] = [])
    callbackArr[eventName].push(callback)
  } else {
    offEvent(eventName, null, true)
    !callbackArr[eventName] && (callbackArr[eventName] = [])
    callbackArr[eventName].push(callback)
  }
  message.$on(eventName, callback)
}

export function onceEvent(eventName, callback) {
  message.$once(eventName, callback)
}

/**
 * 清理侦听
 * @param eventName
 * @param callback
 * @param isAll  为true 时，清理所有侦听
 */
export function offEvent(eventName, callback, isAll) {
  if (!eventName) {
    return
  }
  if (callbackArr[eventName] && callbackArr[eventName].length) {
    let i = callbackArr[eventName].length
    let cb
    while (i--) {
      cb = callbackArr[eventName][i]
      if (isAll || cb === callback) {
        callbackArr[eventName].splice(i, 1)
        message.$off(eventName, cb)
      }
    }
  } else {
    message.$off(eventName, callback)
  }
}

export default {
  emit: emitEvent,
  on: onEvent,
  once: onceEvent,
  off: offEvent
}
